export const STATUS_LABELS = {
  aberto: "Em aberto",
  delegada: "Delegada",
  andamento: "Em andamento",
  aguardando: "Aguardando",
  aguardando_aprovacao: "Aguard. aprovação",
  concluido: "Concluído",
};

export const STATUS_COLORS = {
  aberto: "bg-blue-500/15 text-blue-400 border-blue-500/30",
  delegada: "bg-indigo-500/15 text-indigo-400 border-indigo-500/30",
  andamento: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  aguardando: "bg-violet-500/15 text-violet-400 border-violet-500/30",
  aguardando_aprovacao: "bg-cyan-500/15 text-cyan-400 border-cyan-500/30",
  concluido: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
};

export const PRIORITY_LABELS = {
  baixa: "Baixa",
  media: "Média",
  alta: "Alta",
  critica: "Crítica",
};

export const PRIORITY_COLORS = {
  baixa: "bg-slate-500/15 text-slate-400 border-slate-500/30",
  media: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  alta: "bg-orange-500/15 text-orange-400 border-orange-500/30",
  critica: "bg-red-500/15 text-red-400 border-red-500/30",
};

export const ROLE_LABELS = {
  admin: "Administrador da Plataforma",
  admin_cliente: "Administrador do Cliente",
  gestor: "Gestor",
  coordenador: "Coordenador",
  supervisor: "Supervisor",
  responsavel_tecnico: "Responsável Técnico",
  tecnico: "Técnico Astral",
  cliente: "Cliente",
  auditor: "Auditor",
};

export const OCC_CLASS_LABELS = { cliente: "Ocorrência Cliente", astral: "Ocorrência Astral" };
export const OCC_CLASS_SHORT = { cliente: "Cliente", astral: "Astral" };
export const OCC_CLASS_COLORS = {
  cliente: "bg-sky-500/15 text-sky-400 border-sky-500/30",
  astral: "bg-fuchsia-500/15 text-fuchsia-400 border-fuchsia-500/30",
};

export const FIELD_TYPE_LABELS = { texto: "Texto", numero: "Número", booleano: "Sim/Não", selecao: "Seleção", data: "Data" };
export const REQUIREMENT_LABELS = { obrigatorio: "Obrigatório", opcional: "Opcional", somente_leitura: "Somente leitura" };
export const APP_TYPE_LABELS = { tecnico: "App do Técnico", cliente: "App do Cliente" };

export const CATEGORIES = ["Estrutural", "Higiene", "Roedores", "Moscas", "Baratas", "Grãos Armazenados", "Não Conformidade", "Melhoria", "Outros"];
export const PRIORITIES = ["baixa", "media", "alta", "critica"];
export const STATUSES = ["aberto", "delegada", "andamento", "aguardando", "aguardando_aprovacao", "concluido"];
export const EDITABLE_STATUSES = ["aberto", "andamento", "aguardando"];

export const FEATURE_LABELS = {
  dashboard: "Dashboard",
  ocorrencias: "Ocorrências",
  pendencias: "Pendências",
  cadastros: "Cadastros",
  planos: "Planos de Ação",
  ai: "ASTRAL AI",
  relatorios: "Relatórios",
  monitoramentos: "Monitoramentos",
  usuarios: "Usuários",
  empresas: "Empresas",
  administracao: "Administração",
  auditoria: "Auditoria",
};

export const WORKFLOW_ACTION_LABELS = {
  open_roles: "Abrir ocorrência",
  edit_roles: "Editar ocorrência",
  delete_roles: "Excluir ocorrência",
  request_conclusion_roles: "Solicitar conclusão",
  approve_conclusion_roles: "Aprovar conclusão",
};

export const INDICATOR_LABELS = {
  kpis: "Cards KPI",
  por_mes: "Ocorrências por mês",
  por_categoria: "Por categoria",
  por_unidade: "Por unidade",
  por_area: "Por área",
  por_prioridade: "Por prioridade",
  ranking: "Ranking",
  sla: "SLA",
  pragas: "Pragas por espécie",
  areas_criticas: "Áreas críticas",
  operacional_astral: "Operacional Astral",
  niveis_risco: "Níveis de risco",
  capturas_roedores: "Capturas de roedores",
  salas_saude: "Saúde das salas elétricas",
};

export const CAPTURE_SITUATION_LABELS = { vivo: "Vivo", morto: "Morto" };

export const RISK_LABELS = { verde: "Baixo risco", amarelo: "Atenção", laranja: "Alto risco", vermelho: "Crítico", cinza: "Sem inspeção" };
export const RISK_COLORS = {
  verde: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  amarelo: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  laranja: "bg-orange-500/15 text-orange-400 border-orange-500/30",
  vermelho: "bg-red-500/15 text-red-400 border-red-500/30",
  cinza: "bg-slate-500/15 text-slate-400 border-slate-500/30",
};
export const CHECK_STATUS_LABELS = { conforme: "Conforme", nao_conforme: "Não conforme", nao_aplicavel: "N/A" };

export const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("pt-BR") + " " + d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
};

export const RESP_STATUSES = ["ativo", "ferias", "afastado", "licenca", "desligado"];

export const RESP_STATUS_LABELS = {
  ativo: "Ativo",
  ferias: "Férias",
  afastado: "Afastado",
  licenca: "Licença",
  desligado: "Desligado",
};

export const RESP_STATUS_COLORS = {
  ativo: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  ferias: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  afastado: "bg-orange-500/15 text-orange-400 border-orange-500/30",
  licenca: "bg-violet-500/15 text-violet-400 border-violet-500/30",
  desligado: "bg-red-500/15 text-red-400 border-red-500/30",
};

export const SLA_LABELS = { verde: "No prazo", amarelo: "Atenção", laranja: "Crítico", vermelho: "Estourado" };
export const SLA_DOT = { verde: "bg-emerald-500", amarelo: "bg-amber-400", laranja: "bg-orange-500", vermelho: "bg-red-500" };
export const SLA_TEXT = { verde: "text-emerald-400", amarelo: "text-amber-400", laranja: "text-orange-400", vermelho: "text-red-400" };
export const SLA_BAR = { verde: "bg-emerald-500", amarelo: "bg-amber-400", laranja: "bg-orange-500", vermelho: "bg-red-500" };

export const RECURRENCE_LABELS = { reincidencia: "Reincidência", recorrente: "Recorrente", critica: "Recorrência crítica" };
export const RECURRENCE_COLORS = {
  reincidencia: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  recorrente: "bg-orange-500/15 text-orange-400 border-orange-500/30",
  critica: "bg-red-500/15 text-red-400 border-red-500/30",
};

export const ORIGINS = ["Inspeção Técnica", "Monitoramento", "Armadilha", "Cliente", "Auditoria", "Autoinspeção", "IA", "Importação", "Integração API"];

export const MATCH_LEVEL_LABELS = { subarea: "Mesma subárea", area: "Mesma área", unit: "Mesma unidade" };

export const PLAN_STATUSES = ["aberto", "em_analise", "aguardando_aprovacao", "em_execucao", "aguardando_cliente", "concluido", "validado", "arquivado", "cancelado"];
export const PLAN_OPEN_STATUSES = ["aberto", "em_analise", "aguardando_aprovacao", "em_execucao", "aguardando_cliente"];

export const PLAN_STATUS_LABELS = {
  aberto: "Aberto", em_analise: "Em análise", aguardando_aprovacao: "Aguard. aprovação",
  em_execucao: "Em execução", aguardando_cliente: "Aguard. cliente", concluido: "Concluído",
  validado: "Validado", arquivado: "Arquivado", cancelado: "Cancelado",
};

export const PLAN_STATUS_COLORS = {
  aberto: "bg-blue-500/15 text-blue-400 border-blue-500/30",
  em_analise: "bg-cyan-500/15 text-cyan-400 border-cyan-500/30",
  aguardando_aprovacao: "bg-violet-500/15 text-violet-400 border-violet-500/30",
  em_execucao: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  aguardando_cliente: "bg-fuchsia-500/15 text-fuchsia-400 border-fuchsia-500/30",
  concluido: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  validado: "bg-teal-500/15 text-teal-400 border-teal-500/30",
  arquivado: "bg-slate-500/15 text-slate-400 border-slate-500/30",
  cancelado: "bg-red-500/15 text-red-400 border-red-500/30",
};

export const PLAN_ORIGIN_LABELS = {
  manual: "Manual", reincidencia: "Reincidência", ocorrencia: "Ocorrência crítica",
  sla_vencido: "SLA vencido", monitoramento: "Monitoramento", ia: "IA", auditoria: "Auditoria",
};

export const ACTION_TYPE_LABELS = { corretiva: "Corretiva", preventiva: "Preventiva", melhoria: "Melhoria" };
export const ACTION_STATUS_LABELS = { pendente: "Pendente", em_andamento: "Em andamento", concluida: "Concluída" };

export const EFFECTIVENESS_LABELS = { efetivo: "Efetivo", parcial: "Parcialmente efetivo", ineficaz: "Ineficaz" };
export const EFFECTIVENESS_COLORS = {
  efetivo: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  parcial: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  ineficaz: "bg-red-500/15 text-red-400 border-red-500/30",
};

export const ROOT_CAUSE_METHODS = { livre: "Campo livre", "5porques": "5 Porquês", ishikawa: "Diagrama de Ishikawa", arvore: "Árvore de Causa" };

export const AI_VERDICT_LABELS = {
  aprovado: "Aprovado", aprovado_ressalvas: "Aprovado com ressalvas",
  requer_revisao: "Requer revisão", reprovado: "Reprovado",
};
export const AI_VERDICT_COLORS = {
  aprovado: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  aprovado_ressalvas: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  requer_revisao: "bg-orange-500/15 text-orange-400 border-orange-500/30",
  reprovado: "bg-red-500/15 text-red-400 border-red-500/30",
};
export const PHOTO_AI_STATUS_LABELS = { aprovada: "Aprovada", baixa_qualidade: "Baixa qualidade", reprovada: "Reprovada" };
export const PHOTO_AI_STATUS_COLORS = {
  aprovada: "text-emerald-400", baixa_qualidade: "text-amber-400", reprovada: "text-red-400",
};
export const AI_CONFIDENCE_LABELS = { alta: "Alta confiança", media: "Média confiança", baixa: "Baixa confiança" };
